import { lazy, Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { LazyMotion } from 'framer-motion'
import { AppLayout } from './components/Layout'
import { LoadingState } from './components/ui'
import { loadMotionFeatures } from './lib/motion'

const Landing = lazy(() => import('./routes/Landing'))
const Devices = lazy(() => import('./routes/Devices'))
const DeviceDetail = lazy(() => import('./routes/DeviceDetail'))
const Receipts = lazy(() => import('./routes/Receipts'))
const NewReceipt = lazy(() => import('./routes/NewReceipt'))
const ReceiptDetail = lazy(() => import('./routes/ReceiptDetail'))
const Processing = lazy(() => import('./routes/Processing'))
const Claims = lazy(() => import('./routes/Claims'))
const NewClaim = lazy(() => import('./routes/NewClaim'))
const ClaimDetail = lazy(() => import('./routes/ClaimDetail'))
const Reminders = lazy(() => import('./routes/Reminders'))
const Settings = lazy(() => import('./routes/Settings'))
const NotFound = lazy(() => import('./routes/NotFound'))

function AppRoutes() {
  return (
    <AppLayout>
      <Routes>
        <Route path="/uredaji" element={<Devices />} />
        <Route path="/uredaji/:id" element={<DeviceDetail />} />
        <Route path="/racuni" element={<Receipts />} />
        <Route path="/racuni/novi" element={<NewReceipt />} />
        <Route path="/racuni/:id" element={<ReceiptDetail />} />
        <Route path="/obrada/:jobId" element={<Processing />} />
        <Route path="/reklamacije" element={<Claims />} />
        <Route path="/reklamacije/nova/:deviceId" element={<NewClaim />} />
        <Route path="/reklamacije/:id" element={<ClaimDetail />} />
        <Route path="/podsjetnici" element={<Reminders />} />
        <Route path="/postavke" element={<Settings />} />
        <Route path="/aplikacija" element={<Navigate to="/uredaji" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AppLayout>
  )
}

export default function App() {
  return (
    // `strict` sprječava slučajnu upotrebu punog `motion` importa koji bi vratio
    // cijelu biblioteku u početni paket.
    <LazyMotion features={loadMotionFeatures} strict>
      <Suspense fallback={<LoadingState label="Otvaranje Računka…" />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="*" element={<AppRoutes />} />
        </Routes>
      </Suspense>
    </LazyMotion>
  )
}
